import * as React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Box,
  Container,
  Typography,
  Tabs,
  Tab,
  useMediaQuery,
  BottomNavigation,
  BottomNavigationAction,
  Paper,
} from "@mui/material";
import { CalendarMonth, Inventory2, QueryStats, AddBox } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

function useInviteToken() {
  const { search } = useLocation();
  const qs = new URLSearchParams(search);
  return qs.get("inviteToken") || "";
}

const NAV_ITEMS = [
  { value: "calendar", label: "Plan de collecte", icon: <CalendarMonth /> },
  { value: "equipments", label: "Équipements", icon: <Inventory2 /> },
  { value: "declarations", label: "Declarations", icon: <AddBox /> },
  { value: "stats", label: "Statistiques", icon: <QueryStats /> },
];

export const ExternalLayout: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();
  const navigate = useNavigate();
  const inviteToken = useInviteToken();

  const current = React.useMemo(() => {
    const seg = location.pathname.split("/").pop() || "calendar";
    const found = NAV_ITEMS.find((i) => i.value === seg);
    return found ? found.value : "calendar";
  }, [location.pathname]);

  const go = (to: string) => {
    const qs = inviteToken
      ? `?inviteToken=${encodeURIComponent(inviteToken)}`
      : "";
    navigate(`/externals/${to}${qs}`);
  };

  return (
    <Box
      sx={{
        bgcolor: "#fafafa",
        color: "#000",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "linear-gradient(135deg, #e8f5e9 0%, #e3f2fd 100%)",
      }}
    >
      <AppBar
        position="static"
        color="transparent"
        elevation={0}
        sx={{ borderBottom: "1px solid #eee" }}
      >
        <Toolbar sx={{ gap: 1.5, justifyContent: "center" }}>
          <img
            src="/logo/logo-hubency-horizontal.svg"
            alt="Hubency Trackency Logo"
            style={{ height: 18, verticalAlign: "middle" }}
          />
          <Typography variant="h6">- Trackency</Typography>
        </Toolbar>

        {!isMobile && (
          <Tabs
            value={current}
            onChange={(_, v) => go(v)}
            centered
            indicatorColor="primary"
            textColor="primary"
          >
            {NAV_ITEMS.map((i) => (
              <Tab
                key={i.value}
                value={i.value}
                label={i.label}
                icon={i.icon}
                iconPosition="start"
              />
            ))}
          </Tabs>
        )}
      </AppBar>

      <Container maxWidth="lg" sx={{ flex: 1, py: 4 }}>
        <Outlet />
      </Container>

      <Box
        sx={{
          py: 2,
          textAlign: "center",
          borderTop: "1px solid #eee",
          fontSize: "0.85rem",
          color: "text.secondary",
          pb: isMobile ? 7 : 2, // espace pour bottom nav
        }}
      >
        © {new Date().getFullYear()} HUBENCY — Le Rimbaud, Hall A, 22 av. des
        Nations, CS 40063 Villepinte 95926 Goussainville Cedex — Trackency
      </Box>

      {isMobile && (
        <Paper
          elevation={8}
          sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}
        >
          <BottomNavigation
            showLabels
            value={current}
            onChange={(_, v) => go(v)}
          >
            {NAV_ITEMS.map((i) => (
              <BottomNavigationAction
                key={i.value}
                value={i.value}
                label={i.label}
                icon={i.icon}
              />
            ))}
          </BottomNavigation>
        </Paper>
      )}
    </Box>
  );
};
